import { Component, OnInit, OnDestroy,ViewChild,ElementRef,AfterViewInit } from '@angular/core';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import {ShareService } from './../services/services';
import {Banner,BannerService } from './banner.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Title,BrowserModule,DomSanitizer } from '@angular/platform-browser';

declare var jQuery: any;

@Component({
    selector: 'banner-component',
	//template: require('./banner.component.html'),
	templateUrl: './pg/banner/banner.component.html',	
	providers:[BannerService]
	
})

export class BannerComponent implements OnInit {
	
	public serviceData;
	private _sub: Subscription;
	public descirptionbanner;
	public banners:Array<any>;
	constructor(
	    private http: Http,
	    private _route: ActivatedRoute,
	    private _router: Router,
	    private shareService: ShareService,
	    private _title: Title,
	    private _sanitizer: DomSanitizer,
	    private _bannerService: BannerService) {
		   
		  			  	
		  
	    }
	    

	ngOnInit() {
	   
	 this._sub = this._route.params.subscribe(params => {
				   
			   
			   this._bannerService.getbanner().subscribe(
        data => {
                 // 
                  console.log(data.banner);  
                  
                                           
                   this.banners=data.banner;
                   for(let i=0;i<this.banners.length;i++)
                  {
	                  this.banners[i].description=this._sanitizer.bypassSecurityTrustHtml(this.banners[i].description)
                  }
                   let mainjs=this.shareService.getmainjs();
				   jQuery.getScript('./'+mainjs);
                  // mydata(); 
                   
           
        },
        err => console.error(err),
        () => console.log('banner services completed')
    ); 
			   
			   
			   		   
		});
		
		
	
		
	}
    
    ngOnDestroy() {
       this._sub.unsubscribe();
    }
    
    ngAfterViewInit() {    
        //var data=$('.bannercontainerV1');
       //bannerlistdata();
        //setTimeout(()=>{    //<<<---    using ()=> syntax
        //let mainjs=this.shareService.getmainjs();
        //jQuery.getScript('./'+mainjs);
	 // },500);
          
                  
        }
}


// WEBPACK FOOTER //
// ./resources/assets/typescript/banner/banner.component.ts